import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { ConfirmationDialog } from '../../shared-components';
import './SendEmailConfirmationModal.scss';

interface Props {
  onBackButtonClicked(): void;
  onConfirmButtonClicked(): void;
  isOpen?: boolean;
}

const SendEmailConfirmationModalImpl: React.FC<Props> = props => {
  const {
    onBackButtonClicked,
    onConfirmButtonClicked,
    isOpen,
  } = props;

  const {
    targetGroupStore,
    createOrEditEmailTemplatePageUiStore,
  } = useStores();
  ;
  const targetGroupIdsSet = new Set(createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.targetGroupIds ?? []);

  const renderRecipients = (): string => {
    const groupRecipients = targetGroupStore.targetGroups
      .filter((targetGroup) => targetGroupIdsSet.has(targetGroup.targetGroupId))
      .map((targetGroup) => targetGroup.displayName);

    const individualRecipients = createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.individualRecipients ?? [];

    const allRecipients = [...groupRecipients, ...individualRecipients];

    return allRecipients.join(', ');
  };

  return (
    <ConfirmationDialog
      isOpen={!!isOpen}
      isShowCloseDialog={true}
      className='send-email-confirmation-modal'
      dialogTitle='Send email'
      dialogSubtext={
        <>
          <Text
            block
            as='p'
          >
            Are you sure you would like to send this email to the below recipients? Please ensure you've reviewed the email before sending it.
          </Text>
          <div className='grid-row'>
            <Text weight='semibold'>Email title: </Text>
            <Text>{createOrEditEmailTemplatePageUiStore.emailTemplateRequestBody?.title} </Text>
          </div>
          <div className='grid-row'>
            <Text weight='semibold'>Recipients: </Text>
            <Text>{renderRecipients()}</Text>
          </div>
        </>
      }
      primaryButtonLabel='Confirm'
      secondaryButtonLabel='Back'
      onPrimaryButtonClick={onConfirmButtonClicked}
      onSecondaryButtonClick={onBackButtonClicked}
      onCloseDialogClick={onBackButtonClicked}
    />
  );
}

export const SendEmailConfirmationModal = observer(SendEmailConfirmationModalImpl);
